import React from "react";
import {mailto} from "@opay/lib-core-js";

export const handleEmailSending = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, name: string, domain: string) => {
    e.preventDefault();
    mailto(name, domain);
}
